import { render, staticRenderFns } from "./TelcoFormGeneral.vue?vue&type=template&id=2742499e&"
import script from "./TelcoFormGeneral.vue?vue&type=script&lang=ts&"
export * from "./TelcoFormGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports